import React from 'react';

const Register = () => {
  return (
    <>
      <h1 data-testid="register-placeholder">Placeholder for user registration view</h1>
    </>
  );
};

export default Register;
